/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type {VersionInfo} from '../models/VersionInfo';
import type {CancelablePromise} from '../core/CancelablePromise';
import type {BaseHttpRequest} from '../core/BaseHttpRequest';
export class VersionService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Get the assembly build/modified date information.
   * @returns VersionInfo OK
   * @throws ApiError
   */
  public versionGetVersion(): CancelablePromise<VersionInfo> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/version',
    });
  }
}
